(function (root, factory) {
  if (typeof define === "function" && define.amd) {
    // AMD. Register as an anonymous module.
    define(["leaflet"], factory);
  } else if (typeof modules === "object" && module.exports) {
    // define a Common JS module that relies on 'leaflet'
    module.exports = factory(require("leaflet"));
  } else {
    // Assume Leaflet is loaded into global object L already
    factory(L);
  }
})(this, function (L) {
  "use strict";

  L.TileLayer.Provider = L.TileLayer.extend({
    initialize: function (arg, options) {
      var providers = L.TileLayer.Provider.providers;

      var parts = arg.split(".");

      var providerName = parts[0];
      var variantName = parts[1];

      if (!providers[providerName]) {
        throw "No such provider (" + providerName + ")";
      }

      var provider = {
        url: providers[providerName].url,
        options: providers[providerName].options,
      };

      // overwrite values in provider from variant.
      if (variantName && "variants" in providers[providerName]) {
        if (!(variantName in providers[providerName].variants)) {
          throw "No such variant of " + providerName + " (" + variantName + ")";
        }
        var variant = providers[providerName].variants[variantName];
        var variantOptions;
        if (typeof variant === "string") {
          variantOptions = {
            variant: variant,
          };
        } else {
          variantOptions = variant.options;
        }
        provider = {
          url: variant.url || provider.url,
          options: L.Util.extend({}, provider.options, variantOptions),
        };
      }

      // replace attribution placeholders with their values from toplevel provider attribution,
      // recursively
      var attributionReplacer = function (attr) {
        if (attr.indexOf("{attribution.") === -1) {
          return attr;
        }
        return attr.replace(
          /\{attribution.(\w*)\}/g,
          function (match, attributionName) {
            return attributionReplacer(
              providers[attributionName].options.attribution
            );
          }
        );
      };
      provider.options.attribution = attributionReplacer(
        provider.options.attribution
      );

      // Compute final options combining provider options with any user overrides
      var layerOpts = L.Util.extend({}, provider.options, options);
      L.TileLayer.prototype.initialize.call(this, provider.url, layerOpts);
    },
  });

  L.TileLayer.Provider.providers = {
    OpenStreetMap: {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      options: {
        maxZoom: 19,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>',
      },
      variants: {
        Mapnik: {},
        HOT: {
          url: "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
          options: {
            attribution:
              "{attribution.OpenStreetMap} | " +
              'Tiles by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OSM Team</a> | ' +
              'hosted by <a href="https://openstreetmap.fr/" target="_blank">OSM France</a>',
          },
        },
      },
    },
    MapBox: {
      url:
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}{r}?access_token={accessToken}",
      options: {
        attribution:
          '&copy; <a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a> ' +
          "{attribution.OpenStreetMap} " +
          '<a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a>',
        tileSize: 512,
        maxZoom: 18,
        zoomOffset: -1,
        id: "mapbox/streets-v12",
        accessToken: "<insert your access token here>",
      },
    },
    MapTiler: {
      url:
        "https://api.maptiler.com/maps/{variant}/{z}/{x}/{y}{r}.{ext}?key={key}",
      options: {
        attribution:
          '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap</a>',
        variant: "streets",
        ext: "png",
        key: "<insert your MapTiler Cloud API key here>",
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 0,
        maxZoom: 21,
      },
      variants: {
        Streets: "streets",
        Basic: "basic",
        Bright: "bright",
        Pastel: "pastel",
        Positron: "positron",
        Hybrid: {
          options: {
            variant: "hybrid",
            ext: "jpg",
          },
        },
        Toner: "toner",
        Topo: "topo",
        Voyager: "voyager",
      },
    },
    Stamen: {
      url:
        "https://stamen-tiles-{s}.a.ssl.fastly.net/{variant}/{z}/{x}/{y}{r}.{ext}",
      options: {
        attribution:
          "{attribution.OpenStreetMap} | Tiles by <a href='http://stamen.com' target='_blank'>Stamen Design</a>",
        subdomains: "abcd",
        minZoom: 0,
        maxZoom: 20,
        variant: "toner",
        ext: "png",
      },
      variants: {
        Toner: "toner",
        TonerLite: "toner-lite"
      },
    },
    TomTom: {
      url:
        "https://{s}.api.tomtom.com/map/1/tile/{variant}/{style}/{z}/{x}/{y}.{ext}?key={apikey}",
      options: {
        variant: "basic",
        maxZoom: 22,
        attribution:
          '<a href="https://tomtom.com" target="_blank">&copy;  1992 - ' +
          new Date().getFullYear() +
          " TomTom.</a> ",
        subdomains: "abcd",
        style: "main",
        ext: "png",
        apikey: "<insert your API key here>",
      },
      variants: {
        Basic: "basic",
        Hybrid: "hybrid",
        Labels: "labels",
      },
    },
    Esri: {
      url:
        "https://server.arcgisonline.com/ArcGIS/rest/services/{variant}/MapServer/tile/{z}/{y}/{x}",
      options: {
        variant: "World_Street_Map",
        attribution: "{attribution.OpenStreetMap} | Tiles by Esri",
      },
      variants: {
        WorldStreetMap: {
          options: {
          },
        },
        WorldTopoMap: {
          options: {
            variant: "World_Topo_Map",
          },
        },
        NatGeoWorldMap: {
          options: {
            variant: "NatGeo_World_Map",
            maxZoom: 16,
          },
        },
      },
    },
    CartoDB: {
      url: "https://{s}.basemaps.cartocdn.com/{variant}/{z}/{x}/{y}{r}.png",
      options: {
        attribution:
          '{attribution.OpenStreetMap} | Tiles by <a href="https://carto.com/attributions" target="_blank">CARTO</a>',
        subdomains: "abcd",
        maxZoom: 19,
        variant: "light_all",
      },
      variants: {
        Positron: "light_all",
        DarkMatter: "dark_all"
      },
    },
  };

  L.tileLayer.provider = function (provider, options) {
    return new L.TileLayer.Provider(provider, options);
  };

  return L;
});
